// Path: src\Components\More\Points.jsx
import React, { useState, useEffect, useRef, useCallback } from "react";
import BaseHome from "../Home/BaseHome";
import { Tabs, Tab, Box } from "@mui/material";
import SwipperSlider from "./Imageslider";
import { getpointList, pointList, pointsCategory } from "../../api/points.api";
import { t } from "i18next";
import ListLoader from '../Common/ListLoader'
import TabWithBottomBorder from "../Common/TabWithBottomBorderNewStyle";
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box className="tab-content">{children}</Box>}
    </div>
  );
};

const Vipoints = () => {
  const [value, setValue] = useState(0);
  const [pointCategoryList, setPointCategory] = useState([]);
  const [pointList, setPointList] = useState([]);
  const [sliderList, setSliderList] = useState([]);
  const pointsListRef = useRef(null);

  useEffect(() => {
    fetchPointCategory();
  }, []);
  const fetchPointCategory = async () => {
    try {
      const response = await pointsCategory({ pagination: { sortBy: "createdAt", sortDirection: "asc" } });
      if (response?.success && response?.data) {
        setPointCategory(response?.data)
        fetchPoints(response?.data[0]);
      }
    }
    catch (error) {
    }
  };

  const handleChange = (event, newValue) => {
    setCurrentPage(1)
    setValue(newValue);
    fetchPoints(pointCategoryList[newValue]);
  };

  useEffect(() => {
    // Center the first item in the points list when the page loads
    const pointsList = pointsListRef.current;
    if (pointsList && pointsList.children.length > 0) {
      const firstItem = pointsList.children[0];
      const firstItemWidth = firstItem.offsetWidth;
      const containerWidth = pointsList.offsetWidth;
      const scrollToPosition = (firstItemWidth - containerWidth) / 2;
      pointsList.scrollLeft = scrollToPosition;
    }
  }, []);



  //infinite scroll
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])
  const loadMore = async () => {
    setLoading(true)
    fetchPoints(pointCategoryList[value])

  }
  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      console.log(loading)
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        console.log(entries[0].isIntersecting)
        if (entries[0].isIntersecting) {
          if (currentPage < totalPages - 1)
            setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );
  const fetchPoints = async (category) => {
    try {
      if (category == null && category == undefined) {
        return;
      }

      const response = await getpointList({ pagination: { pageNo: currentPage, recordPerPage: recordPerPage, sortBy: "order", sortDirection: "asc" }, search: { pointCategory: category?._id } });
      setLoading(false)
      if (response?.success && response?.data) {
        setTotalPages(response?.totalPages)
        setPointList(response?.data)
        if (response?.games) {
          setSliderList(response?.games)
        } else {
          setSliderList([])
        }

      } else {
        setPointList([])
        setSliderList([])
      }
    }
    catch (error) {
      setLoading(false)
    }
  };
  const [pointCategoryTab,setPointCategoryTabList] = useState([])
  useEffect(()=>{
    if(pointCategoryList){
      let temp =[]
      pointCategoryList.forEach((category)=>{
        temp.push(category?.name)
      })
      setPointCategoryTabList(temp)
    }
  },[pointCategoryList])
  const getTabContent = () => {
    // switch (tabs) {
    //   case 0:
    //     return <div className="mytab-content"></div>;
    //   case 1:
    //     return <div className="mytab-content"></div>;

    //   default:
    //     return null;
    // }
  };
  const [activeTab, setActiveTab] = useState(0)
  useEffect(()=>{
    handleChange(null,activeTab)
  },[activeTab])
  
  return (
    <BaseHome title={t("moreMenu.vi_points")} isFooter={false} isMore={true}>
      <div className="commontabs testimonial-tabs autosize-tab">
        <div className="commontabs-innerwrap tab-backgrounnd-new-style">
        <TabWithBottomBorder getTabContent={getTabContent}  tabs={pointCategoryTab} activeTab={activeTab} setActiveTab={setActiveTab} setValue={setValue} />
          {/* <Tabs
            value={value}
            onChange={handleChange}
            className="tabs-container"
          >
            {pointCategoryList?.map((category, index) => {
              return <Tab
                label={category?.name}
                className="tab tabs-font-size"
                style={{ textTransform: "lowercase" }}
              />;
            })}
          </Tabs> */}
        </div>
      </div>

      {
        pointCategoryList?.length > 0 ?
          <TabPanel value={value} index={value} className="autosize-tab-caontent">
            {sliderList && sliderList.length > 0 ?
              <div className="banerrr">
                <SwipperSlider data={sliderList} />
              </div> : <></>
            }

            <div className="points-container" >

              {value === 0 ? <div className="points-swipper-sliderr"></div> : <></>}

              <div className="points-list mt-2" ref={pointsListRef}>
                {pointList?.length > 0 ? pointList?.map((point, index) =>
                  <div className="points-item"
                    key={point._id}
                    ref={lastPostElementRef}
                  >
                    <span>{point?.name}</span>
                    <span className="points-value">{point?.points} {t("leaderboard.points")}</span>
                  </div>
                ) : !loading && <><div className="no-record-found-center">{t("points.no_data_found")}</div></>}
                {/* {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>} */}
              </div>
            </div>
          </TabPanel> : !loading && <> <div className="no-record-found-center">{t("points.no_data_found")}</div></>

      }

      {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}

    </BaseHome>
  );
};

export default Vipoints;
